import { render } from "./TreeVersion2Component.vue?vue&type=template&id=1572b2e1"
import script from "./TreeVersion2Component.vue?vue&type=script&lang=js"
export * from "./TreeVersion2Component.vue?vue&type=script&lang=js"

import "./TreeVersion2Component.vue?vue&type=style&index=0&id=1572b2e1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__